import {
	DEPRECATED__CLAIMS_ONLY_USER__ACCOUNT_TYPE,
	DEPRECATED__EMPLOYEE__ACCOUNT_TYPE,
	DEPRECATED__READ_ONLY_USER__ACCOUNT_TYPE,
} from '../context/auth';
import { legacyPermissions, Permission } from '../permissions';

const hasPermissionForAuth = (
	permissions: Permission[],
	permissionName: Permission,
	rolesAndPermissionsEnabled?: boolean,
	accountType?: string,
) => {
	if (!permissionName || !permissions) {
		return false;
	}

	if (rolesAndPermissionsEnabled) {
		const [permissionScope, permissionAction] = permissionName.split('.');

		if (permissions.includes('*.*')) {
			return true;
		}

		if (permissions.includes(`*.fetch`) && permissionAction === 'fetch') {
			return true;
		}

		if (permissions.includes(`${permissionScope}.*` as Permission)) {
			return true;
		}
		return permissions.includes(permissionName);
	} else {
		switch (accountType) {
			case DEPRECATED__READ_ONLY_USER__ACCOUNT_TYPE:
				/**
				 * https://socotra.atlassian.net/browse/SOCA-8016
				 * 'analytics.fetch' is technically included with the READ_ONLY_USER role,
				 * but the API does not support it and it wasn't available before Roles and Permission.
				 * This will be removed once Roles and Permissions is fully rolled out.
				 */
				if (permissionName === 'analytics.fetch') {
					return false;
				}
				if (
					hasPermissionForAuth(
						legacyPermissions[DEPRECATED__READ_ONLY_USER__ACCOUNT_TYPE],
						permissionName,
						true,
					)
				) {
					return true;
				} else {
					return false;
				}
			case DEPRECATED__CLAIMS_ONLY_USER__ACCOUNT_TYPE:
				if (
					hasPermissionForAuth(
						legacyPermissions[DEPRECATED__CLAIMS_ONLY_USER__ACCOUNT_TYPE],
						permissionName,
						true,
					)
				) {
					return true;
				} else {
					return false;
				}
			case DEPRECATED__EMPLOYEE__ACCOUNT_TYPE:
				if (
					hasPermissionForAuth(
						legacyPermissions[DEPRECATED__EMPLOYEE__ACCOUNT_TYPE],
						permissionName,
						true,
					)
				) {
					return true;
				} else {
					return false;
				}
			default:
				return false;
		}
	}
};

export default hasPermissionForAuth;
